import React, { useState, useEffect, useReducer, useRef, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import {
    Toolbar,
    Paper,
    Button,
    Grid,
    Typography,
    Checkbox,
    FormControlLabel,
} from '@material-ui/core';

import { grey } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

import SaveIcon from '@material-ui/icons/Save';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';

import { Formik } from 'formik';

import SideMenu from '../../components/SideMenu';
import Alert from '../../components/Alert';
import Input from '../../components/Input';
import Select from '../../components/Select';
import Popup from '../../components/Popup';
import Autocomplete from '../../components/Autocomplete';
import { ListPageHeading } from '../../components/ListPageLayout';

import api from '../../services/api';
import config from '../../configs/config';
import { PermissionsContext } from '../../providers/Permissions';
const { host, port } = config;

const reduceDevices = (state, action) => {
    let newValues = [];
    console.log({ state })
    switch (action.type) {
        case 'single':
            if (action.checked && !state[action.deviceArray].includes(action.id)) {
                newValues = state[action.deviceArray];
                newValues.push(action.id);
            } else if (!action.checked && state[action.deviceArray].includes(action.id)) {
                newValues = state[action.deviceArray];
                let index = state[action.deviceArray].indexOf(action.id);
                newValues.splice(index, 1);
            } else {
                newValues = state[action.deviceArray];
            }
            return {
                ...state,
                [action.deviceArray]: newValues,
            }
        case 'all':
            if (action.checked) {
                newValues = state[action.deviceArray];
                for (let current of action.allDevices) {
                    if (!newValues.includes(current.id)) {
                        newValues.push(current.id);
                    }
                }
            } else {
                newValues = [];
            }
            return {
                ...state,
                [action.deviceArray]: newValues,
            }
        case 'load':
            newValues = action.loading;
            return {
                ...state,
                [action.deviceArray]: newValues.map(device => device.id),
            };
        case 'reset':
            return { device_id: [], camera_id: [] };
        default: return state;
    }
};

export default function WantedModify() {
    const classes = useStyles();

    const {
        PermissionWrapper,
    } = useContext(PermissionsContext);

    const { id } = useParams();
    const history = useHistory();

    let [wanted, setWanted] = useState({
        name: '',
        sex: 'unknown',
        role: 'visitor',
        face_image: null,
        notes: '',
        user_custom_inputs: [],
    });

    const [search, setSearch] = useState('');
    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const [deviceIds, dispatchDeviceIds] = useReducer(reduceDevices, { device_id: [], camera_id: [] });

    const [image, setImage] = useState(null)

    const [loop, setLoop] = useState(0);
    const [newImage, setNewImage] = useState(false);
    const imageRef = useRef(null);

    function imageHandler(e, values) {
        console.log(e)
        setNewImage(true)
        const reader = new FileReader()
        reader.onload = () => {
            if (reader.readyState === 2) {
                setImage(reader.result);
                values.face_image = e.target.files[0];
                console.log(e.target.files[0])
            }
        }
        reader.readAsDataURL(e.target.files[0]);
        // console.log("imagem: " + image)
    }


    const ImagePreview = ({ image }) => {
        const src = newImage ? image : URL.createObjectURL(image);

        return (
            <img
                src={src}
                alt="Imagem de identificação"
                style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
        );
    };

    const [cameras, setCameras] = useState([]);
    const [userCustomInputs, setUserCustomInputs] = useState([]);

    const dataUrlToFile = async dataUrl => {
        const image = await fetch(dataUrl)
            .then(res => res.arrayBuffer())
            .then(buffer => new File([buffer], 'face_image.jpeg', { type: 'image/jpg' }));

        return image;
    };

    useEffect(() => {
        const loadUser = async () => {
            try {
                const result = await api.get(`/wanted/detail/${id}`);

                let { user, inputs } = result.data;

                user.user_custom_inputs = inputs;

                setUserCustomInputs(inputs)

                const image = await dataUrlToFile(`https://${host}:${port}/midias/imagem/face/${user.face_image}`);

                user.face_image = image;
                setImage(image);

                dispatchDeviceIds({
                    type: 'load',
                    deviceArray: 'camera_id',
                    loading: user.cameras,
                });

                setWanted(user);

            }
            catch (err) {
                console.log({ err });
                setMessage({
                    open: true,
                    variant: 'error',
                    text: err.error,
                });
                setTimeout(() => {
                    history.goBack();
                }, 2000);
            }
        };

        loadUser();
        // eslint-disable-next-line
    }, [id, history]);

    useEffect(() => {
        const findCameras = async () => {
            try {
                const result = await api.get('/camera/list', {
                    params: {
                        search,
                        limit: 30,
                    }
                });

                const { cameras } = result.data;

                setCameras(cameras);
                console.log({ cameras })
            }
            catch (err) {
                console.log(err);
            }
        };

        findCameras();
        // es-li
    }, [search]);

    const saveUser = async (values, formik) => {
        try {

            const data = new FormData();

            data.append('face_image', values.face_image);

            if (!values.org_id) values.org_id = undefined;

            const userData = {
                ...values,
                camera_id: deviceIds.camera_id,
            };

            userData.face_image = undefined;

            data.append('user_data', JSON.stringify(userData));
            // console.log("user data :|", userData)
            const result = await api.post(`/wanted/modify/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            const { user } = result.data;

            formik.setSubmitting(false);

            setMessage({
                open: true,
                variant: 'success',
                text: `Procurado ${user.name} editado com sucesso!`,
            });
        }
        catch (err) {
            // console.log(err)
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    };

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };


    const [customInputs, setCustomInputs] = useState([]);

    useEffect(() => {
        const findInputs = async () => {
            try {
                const result = await api.get('/custom_input/list', {
                    params: {
                        target: ['wanted'],
                        page: 0,
                        limit: 30,
                    }
                });

                const { custom_inputs } = result.data;

                setCustomInputs(custom_inputs);
            }
            catch (err) {
                console.log(err);
            }
        };

        findInputs();
    }, []);

    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const deleteWanted = async () => {
        try {
            setIsDeleting(true);

            const result = await api.delete(`/wanted/delete/${id}`);

            const { success } = result.data;

            setIsDeleting(false);

            if (success) {
                setMessage({
                    open: true,
                    variant: 'success',
                    text: `Procurado deletado com sucesso!`,
                });
            }
            history.goBack();
        } catch (err) {
            setIsDeleting(false);
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    }

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3} className={classes.pageGrid}>
                    <Grid item xs={12}>
                        <div className={classes.pageHeader}>
                            <ListPageHeading icon="person" title="Editar pessoa procurada" />
                            <Typography className={classes.pageSubtitle}>
                                Atualize a identificação, as características e as câmeras utilizadas no monitoramento.
                            </Typography>
                        </div>
                    </Grid>
                    <Formik
                        enableReinitialize={true}
                        initialValues={wanted}
                        onSubmit={saveUser}
                    >
                        {({ values, setFieldValue, handleChange, handleSubmit, isSubmitting }) => (
                            <>
                                <Grid item xs={12}>
                                    <Paper elevation={0} className={classes.paper}>
                                        <form id="wanted-modify" onSubmit={handleSubmit} className={classes.form}>
                                            <div className={classes.formHeader}>
                                                <Typography className={classes.formHeaderTitle}>
                                                    Informações da pessoa procurada
                                                </Typography>
                                                <Typography className={classes.formHeaderSubtitle}>
                                                    Revise os dados cadastrados e salve somente as alterações necessárias.
                                                </Typography>
                                            </div>
                                            <div className={classes.formBody}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} md={4} lg={3} className={classes.photoSection}>
                                                    <div className={classes.faceImageContainer}
                                                        style={{
                                                            height: '300px',
                                                            width: '100%',
                                                        }}>
                                                        <div
                                                            className={classes.faceImageContent}
                                                            style={{
                                                                width: "100%",
                                                                height: "200px"
                                                            }}
                                                        >
                                                            {image ? (
                                                                <ImagePreview image={image} />
                                                            ) : (
                                                                <div className={classes.noImage}>
                                                                    <PhotoCameraIcon />
                                                                    <Typography variant="subtitle2">
                                                                        SEM IMAGEM
                                                                    </Typography>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {image && (
                                                            <Button
                                                                className={classes.removeImageButton}
                                                                size="small"
                                                                type="button"
                                                                variant="outlined"
                                                                color="secondary"
                                                                endIcon={<DeleteIcon />}
                                                                fullWidth
                                                                onClick={() => {
                                                                    setFieldValue('face_image', null)
                                                                    setImage(null);
                                                                    imageRef.current.value = null;
                                                                }}
                                                            >
                                                                Remover
                                                            </Button>
                                                        )}
                                                        <Button
                                                            className={classes.faceImageButton}
                                                            type="button"
                                                            variant="outlined"
                                                            color="primary"
                                                            endIcon={<PhotoCameraIcon />}
                                                            fullWidth
                                                            id={'take_pic'}
                                                            component="label"
                                                        >
                                                            Adicionar Foto
                                                            <input
                                                                name='map_image'
                                                                type="file"
                                                                accept="image/*"
                                                                ref={imageRef}
                                                                onChange={(e) => imageHandler(e, values)}
                                                                hidden
                                                                required={false}
                                                            />
                                                        </Button>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12} md={8} lg={9} className={classes.formSection}>
                                                    <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                        DADOS PESSOAIS
                                                    </Typography>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} md={9}>
                                                            <Input
                                                                label="Nome/Apelido"
                                                                textFieldProps={{
                                                                    name: 'name',
                                                                    placeholder: 'Nome/Apelido',
                                                                    onChange: (e) => {
                                                                        const letras = e.target.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, '');
                                                                        setFieldValue('name', letras);
                                                                    },
                                                                    value: values.name,
                                                                    fullWidth: true,
                                                                    required: false,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={3}>
                                                            <Select
                                                                label="Sexo"
                                                                options={[
                                                                    { label: '-- Selecione --', value: 'unknown', id: 'unknown' },
                                                                    { label: 'Masculino', value: 'male', id: 'male' },
                                                                    { label: 'Feminino', value: 'female', id: 'female' },
                                                                ]}
                                                                textFieldProps={{
                                                                    name: 'sex',
                                                                    onChange: handleChange,
                                                                    fullWidth: true,
                                                                    value: values.sex,
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} className={classes.formSection} style={{ marginTop: '10px' }}>
                                                        <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                            OBSERVAÇÕES
                                                        </Typography>
                                                        <Grid item xs={12} style={{ height: '100%' }}>
                                                            <textarea
                                                                placeholder="Escreva o texto aqui"
                                                                multiline
                                                                minRows={25}
                                                                className={classes.notesField}
                                                                value={values.notes}
                                                                onChange={({ target }) => setFieldValue('notes', target.value)}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container className={classes.formSection}>
                                                <Typography variant="subtitle1" className={classes.formSectionTitleTwo}>
                                                    INFORMAÇÕES PERSONALIZADAS
                                                </Typography>
                                                <Grid container spacing={3}>
                                                    {userCustomInputs.map((input, index) => {
                                                        if (index === 0 && values.user_custom_inputs.length !== userCustomInputs.length && loop === 0) {
                                                            // console.log('0 loop')
                                                            setLoop(1)
                                                            values.user_custom_inputs = userCustomInputs

                                                        }


                                                        let label = '';
                                                        let is_required = '';
                                                        let ciType = '';
                                                        let ciOptions = [];
                                                        customInputs.forEach(ci => {
                                                            if (ci.id === input.custom_input_id) {
                                                                label = ci.name;
                                                                is_required = ci.is_required
                                                                ciType = ci?.type;
                                                                ciOptions = ci?.options;
                                                            }
                                                        });
                                                        return (
                                                            <Grid key={index} item xs={12} sm={6} md={4}>
                                                                {
                                                                    ciType === "normal" ? (
                                                                        <Input
                                                                            label={label}
                                                                            textFieldProps={{
                                                                                name: `user_custom_inputs[${index}].information`,
                                                                                onChange: handleChange,
                                                                                value: values.user_custom_inputs[index]['information'] ? values.user_custom_inputs[index]['information'] : '',
                                                                                fullWidth: true,
                                                                                required: is_required,
                                                                            }}
                                                                        />
                                                                    ) : (

                                                                        <Autocomplete
                                                                            label={label}
                                                                            id={`custom_inputs${index}.information`}
                                                                            options={ciOptions?.length && ciOptions?.map((option) => ({ name: option, value: option, id: option }))}
                                                                            getOptionLabel={({ name }) => name || ''}
                                                                            onChange={(_, value) => setFieldValue(`user_custom_inputs[${index}].information`, value)}
                                                                            getOptionSelected={(option, value) => (option.id === value.id)}
                                                                            /* onInputChange={(_, value) => setPersonTypeSearch(value)} */
                                                                            value={values.user_custom_inputs[index]['information'] ? values.user_custom_inputs[index]['information'] : ''}
                                                                            required={is_required}
                                                                            fullWidth
                                                                        />
                                                                    )
                                                                }
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} className={classes.formSection}>
                                                <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                    CÃMERAS
                                                </Typography>
                                                <Grid item xs={12}>
                                                    <Grid container className={classes.cameraToolbar}>
                                                        <Input
                                                            icon={<SearchIcon style={{ color: grey[400] }} />}
                                                            iconPosition="start"
                                                            textFieldProps={{
                                                                placeholder: 'Buscar…',
                                                                onChange: ({ target }) => setSearch(target.value),
                                                            }}
                                                        />
                                                        <Button
                                                            variant="outlined"
                                                            className={classes.secondaryButton}
                                                            onClick={() => {
                                                                dispatchDeviceIds({
                                                                    type: 'all',
                                                                    checked: true,
                                                                    deviceArray: 'camera_id',
                                                                    allDevices: cameras,
                                                                });
                                                            }}
                                                        >
                                                            Selecionar todos
                                                        </Button>
                                                        <Button
                                                            variant="outlined"
                                                            className={classes.secondaryButton}
                                                            onClick={() => {
                                                                dispatchDeviceIds({
                                                                    type: 'all',
                                                                    checked: false,
                                                                    deviceArray: 'camera_id',
                                                                });
                                                            }}
                                                        >
                                                            Desmarcar todos
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={3}>
                                                    {!!cameras && cameras.map((camera, index) => {
                                                        return (
                                                            <Grid item xs={12} sm={6} md={4} key={camera.id}>
                                                                <FormControlLabel
                                                                    label={
                                                                        <Typography variant="subtitle2" style={{
                                                                            userSelect: 'none'
                                                                        }}>
                                                                            {camera.name}
                                                                            <Typography variant="caption">
                                                                                ({camera?.place_cameras?.name})
                                                                            </Typography>
                                                                        </Typography>
                                                                    }
                                                                    control={
                                                                        <Checkbox
                                                                            name={`camera_[${camera.id}]`}
                                                                            checked={deviceIds.camera_id.includes(camera.id)}
                                                                            color="primary"
                                                                            onChange={(e) => {
                                                                                dispatchDeviceIds({
                                                                                    type: 'single',
                                                                                    checked: e.target.checked,
                                                                                    deviceArray: 'camera_id',
                                                                                    id: camera.id
                                                                                });
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                            </div>
                                            <div className={classes.formActions}>
                                                <PermissionWrapper route="/procurado/deletar/:id">
                                                    <Button
                                                        disabled={isDeleting}
                                                        variant="contained"
                                                        color="secondary"
                                                        endIcon={<DeleteIcon />}
                                                        onClick={() => setOpenDeletePopup(true)}
                                                        className={classes.deleteButton}
                                                    >
                                                        Deletar procurado
                                                    </Button>
                                                </PermissionWrapper>
                                                <Button
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    variant="contained"
                                                    form="wanted-modify"
                                                    color="primary"
                                                    endIcon={<SaveIcon />}
                                                    className={classes.saveButton}
                                                >
                                                    {isSubmitting ? 'Salvando...' : 'Salvar dados'}
                                                </Button>
                                            </div>
                                        </form>
                                    </Paper>
                                </Grid>
                            </>
                        )}
                    </Formik>
                </Grid>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
            <Popup
                openPopup={openDeletePopup}
                setOpenPopup={setOpenDeletePopup}
                title="Excluir pessoa procurada"
                width="92%"
                maxWidth="sm"
            >
                <div className={classes.deleteModal}>
                    <Typography className={classes.deleteModalTitle}>
                        Confirmar exclusão
                    </Typography>
                    <Typography className={classes.deleteModalText}>
                        Deseja realmente excluir esta pessoa procurada? Esta ação não poderá ser desfeita.
                    </Typography>
                    <div className={classes.deleteModalActions}>
                        <Button
                            variant="outlined"
                            onClick={() => setOpenDeletePopup(false)}
                            className={classes.cancelButton}
                        >
                            Cancelar
                        </Button>
                        <Button
                            disabled={isDeleting}
                            variant="contained"
                            onClick={() => deleteWanted()}
                            color="secondary"
                            endIcon={<DeleteIcon />}
                            className={classes.confirmDeleteButton}
                        >
                            {isDeleting ? 'Excluindo...' : 'Excluir pessoa'}
                        </Button>
                    </div>
                </div>
            </Popup>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
    },
    content: {
        flexGrow: 1,
        minWidth: 0,
        padding: theme.spacing(3),
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(6),
        [theme.breakpoints.down('xs')]: { padding: theme.spacing(2) },
    },
    pageGrid: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 1440,
    },
    pageHeader: {
        display: 'flex',
        flexDirection: 'column',
    },
    pageSubtitle: {
        color: '#64748b',
        fontSize: '.82rem',
        lineHeight: 1.5,
        marginLeft: 64,
        marginTop: theme.spacing(.5),
        [theme.breakpoints.down('xs')]: { marginLeft: 0 },
    },
    paper: {
        backgroundColor: '#f8fafc',
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        boxShadow: '0 10px 30px rgba(15, 23, 42, .05)',
        overflow: 'hidden',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formHeader: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #e5e7eb',
        padding: theme.spacing(2.5, 3),
        [theme.breakpoints.down('xs')]: { padding: theme.spacing(2) },
    },
    formHeaderTitle: {
        color: '#1e293b',
        fontSize: '1rem',
        fontWeight: 700,
    },
    formHeaderSubtitle: {
        color: '#64748b',
        fontSize: '.78rem',
        lineHeight: 1.45,
        marginTop: 2,
    },
    formBody: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: { padding: theme.spacing(2) },
    },
    photoSection: {
        marginBottom: theme.spacing(1),
    },
    formSection: {
        backgroundColor: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 14,
        marginBottom: theme.spacing(2.5),
        padding: theme.spacing(2.25),
        [theme.breakpoints.down('xs')]: { padding: theme.spacing(1.75) },
    },
    formSectionTitle: {
        color: '#334155',
        fontSize: '.78rem',
        fontWeight: 800,
        letterSpacing: '.055em',
        marginBottom: theme.spacing(1.75),
        width: '100%',
    },
    formSectionTitleTwo: {
        color: '#334155',
        fontSize: '.78rem',
        fontWeight: 800,
        letterSpacing: '.055em',
        marginBottom: theme.spacing(1.75),
        width: '100%',
    },
    faceImageContainer: {
        width: '100%',
        height: '303px',
        backgroundColor: '#fff',
        border: '1px solid #dbe3ec',
        borderRadius: 14,
        boxShadow: '0 6px 18px rgba(15, 23, 42, .06)',
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    faceImageContent: {
        width: '100%',
        flex: 7,
        background: 'linear-gradient(145deg, #f8fafc 0%, #eef4fb 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(1),
        '& img': { borderRadius: 9, objectFit: 'contain' },
    },
    faceImageButton: {
        borderBottom: 0,
        borderLeft: 0,
        borderRadius: 0,
        borderRight: 0,
        flex: 1,
        fontWeight: 600,
        minHeight: 42,
        textTransform: 'none',
    },
    removeImageButton: {
        borderBottom: 0,
        borderLeft: 0,
        borderRadius: 0,
        borderRight: 0,
        fontWeight: 600,
        minHeight: 40,
        textTransform: 'none',
    },
    noImage: {
        textAlign: 'center',
        color: '#94a3b8',
        '& svg': { fontSize: 42, marginBottom: theme.spacing(.5) },
        '& h6': { fontSize: '.72rem', fontWeight: 700, letterSpacing: '.08em' },
    },
    notesField: {
        backgroundColor: '#fff',
        border: '1px solid #cbd5e1',
        borderRadius: 10,
        boxSizing: 'border-box',
        color: '#475569',
        fontFamily: 'inherit',
        fontSize: '.9rem',
        lineHeight: 1.5,
        minHeight: 170,
        outline: 'none',
        padding: theme.spacing(1.5),
        resize: 'vertical',
        width: '100%',
        '&:focus': {
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, .12)',
        },
    },
    cameraToolbar: {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
        '& .MuiTextField-root': { minWidth: 260 },
        [theme.breakpoints.down('sm')]: {
            alignItems: 'stretch',
            flexDirection: 'column',
            '& .MuiTextField-root': { minWidth: 0, width: '100%' },
        },
    },
    secondaryButton: {
        backgroundColor: '#fff',
        borderColor: '#cbd5e1',
        borderRadius: 9,
        color: '#334155',
        fontWeight: 700,
        minHeight: 42,
        textTransform: 'none',
    },
    formActions: {
        alignItems: 'center',
        backgroundColor: '#fff',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        gap: theme.spacing(1.5),
        justifyContent: 'flex-end',
        padding: theme.spacing(2, 3),
        [theme.breakpoints.down('xs')]: {
            alignItems: 'stretch',
            flexDirection: 'column-reverse',
            padding: theme.spacing(1.5, 2),
        },
    },
    deleteButton: {
        borderRadius: 9,
        fontWeight: 700,
        marginRight: 'auto',
        minHeight: 44,
        textTransform: 'none',
        [theme.breakpoints.down('xs')]: { marginRight: 0, width: '100%' },
    },
    saveButton: {
        borderRadius: 9,
        boxShadow: '0 6px 14px rgba(25, 118, 210, .2)',
        fontWeight: 700,
        minHeight: 44,
        minWidth: 180,
        textTransform: 'none',
        [theme.breakpoints.down('xs')]: { width: '100%' },
    },
    deleteModal: {
        paddingTop: theme.spacing(.5),
    },
    deleteModalTitle: {
        color: '#7f1d1d',
        fontSize: '.95rem',
        fontWeight: 700,
    },
    deleteModalText: {
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: 12,
        color: '#991b1b',
        fontSize: '.82rem',
        lineHeight: 1.5,
        marginTop: theme.spacing(1),
        padding: theme.spacing(1.5),
    },
    deleteModalActions: {
        display: 'flex',
        gap: theme.spacing(1),
        justifyContent: 'flex-end',
        marginTop: theme.spacing(2),
        [theme.breakpoints.down('xs')]: { flexDirection: 'column-reverse' },
    },
    cancelButton: {
        borderColor: '#cbd5e1',
        borderRadius: 9,
        color: '#475569',
        fontWeight: 600,
        textTransform: 'none',
    },
    confirmDeleteButton: {
        borderRadius: 9,
        fontWeight: 700,
        textTransform: 'none',
    },
}));
